<template>
  <div>
    <el-tag
      :type="`${
        !type ? 'danger' : type.includes('Nocturna') ? 'secondary' : 'info'
      }`"
    >
      {{ type ? type : $t('common_words.no_assignment') }}
    </el-tag>
  </div>
</template>
<script>
export default {
  name: 'hour-time-format',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
</script>
